// Layouts
import selectFilter from '../js/modules/selectFilter';

// Elements

// Blocks
import '../scss/blocks/bar_article-filter.scss';
import '../scss/blocks/hero_blog.scss';

// Layouts
import '../scss/layouts/list_article-card.scss';

// Init modules
selectFilter();
